import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

export default {
	htmlString(data) {
		return documentToHtmlString(data, {
			renderNode: {
				[BLOCKS.EMBEDDED_ASSET]: ({
					data: {
						target: { fields }
					}
				}) => `<img src="${fields.file.url}" alt="${fields.description}"/>`,
				[BLOCKS.PARAGRAPH]: (node, next) => `<p>${next(node.content).replace(/\n/g, `</br>`)}</p>`,
				[INLINES.HYPERLINK]: (node, next) => {
					if (node.data.uri.includes('http') || node.data.uri.includes('https')) {
						return `<a href="${node.data.uri}" target="_blank">${next(node.content)}</a>`;
					}
					if (node.data.uri.includes('mailto')) {
						return `<a href="${node.data.uri}" target="_blank">${next(node.content)}</a>`;
					}
				}
			}
		});
	}
};
